<div class="modal-header" *ngIf="item">
  <h4 class="modal-title">#{{ item.id }} - {{ item.cliente }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('cancel')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="container mt-5 mb-5" *ngIf="item?.id">
    <div class="row">
      <div class="from-group col-12">
        <label for="">{{ item.descripcion }}</label>
      </div>
      <div class="form-group col-12">
        <label for="">Seleccione un estado</label>
        <select required name="estadoSel" [(ngModel)]="estadoSel" class="form-control form-sm">
          <option [ngValue]="null" disabled selected>-- Seleccione un estado --</option>
          <option *ngFor="let d of estados" [ngValue]="d">{{ d | titlecase }}</option>
        </select>
        <small id="helpId" class="text-muted">Seleccione un estado</small>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('cancel')">Cerrar</button>
  <button type="button" class="btn btn-primary" (click)="doAction()">Guardar</button>
</div>